export default {"src":"/_next/static/media/squares.8fc6df95.svg","height":878,"width":878};